// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"da1b5b06","124":"01425172","307":"22247464","598":"4a9636ac","642":"a1145af5","658":"680502d8"}[chunkId] + ".css";
};